import { availableLanguages } from "./languages";

export const getLangName = (value: string) => availableLanguages.find(l => l.value === value)?.name;